module.exports = __webpack_public_path__ + "img/thumbnails-16-relaxer-app.913230d9.png";